import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UserProfile } from '../../../core/models/user/user-profile';
import { EkycStatus } from '../../../core/enum/ekyc-status.enum';
import { Role } from '../../../core/enum/role.enum';
import { StorageService } from '../../../core/services/storage.service';

@Component({
    selector: 'app-profile-onboarding-checklist',
    templateUrl: './profile-onboarding-checklist.component.html',
    styleUrls: ['./profile-onboarding-checklist.component.scss'],
    standalone: false
})
export class ProfileOnboardingChecklistComponent implements OnInit {
  @Input() form: UntypedFormGroup;
  // INC-289: profile-details.component.ts's identity/contact fields moved
  // into IdentitySectionFormComponent/ContactSectionFormComponent, each with
  // their own FormGroup — passed through so the error summary below still
  // sees their validation errors.
  @Input() additionalForms: UntypedFormGroup[] = [];
  @Input() isEligibleToInvest: boolean;
  @Input() profile: UserProfile;

  role: Role;
  public Role: typeof Role = Role;

  isCollapsed: boolean = false;

  EkycStatus: typeof EkycStatus = EkycStatus;

  errorFilterFn = (
    error: { name: string; message: string },
    index: number,
    array: { name: string; message: string }[],
  ) => {
    const isCheckExist = array.some((field) => field.name === 'isCheck');

    if (array.length === 0) {
      // If there are no errors, return false
      return false;
    } else if (array.length === 1) {
      // If there is only one error
      return !isCheckExist; // Hide if `isCheck` exists, otherwise show
    } else {
      // If there are multiple errors, always show
      return true;
    }
  };

  constructor(private storageService: StorageService) {}

  ngOnInit() {
    this.role = this.storageService.role;
  }

  isErrorsExist() {
    if (!this.form || !this.form?.errors || !this.profile || !Array.isArray(this.form?.errors))
      return false;

    return this.form?.errors?.filter(this.errorFilterFn).length > 0;
  }
}
